module.exports = __webpack_public_path__ + "static/media/tm-colorit-8.0fd7d455.webp";